import { Link } from "react-router-dom";
import { genres } from "@/mocks/movies";

export default function CategorySidebar() {
  return (
    <aside className="hidden lg:block lg:w-64 lg:shrink-0">
      <div className="sticky top-20 rounded-lg border border-background-200 bg-background-100 p-4">
        <div className="mb-3 flex items-center gap-2">
          <i className="ri-apps-2-line text-lg text-primary-600" />
          <h2 className="font-heading text-sm font-bold text-foreground-950">
            电影分类
          </h2>
        </div>
        <nav className="flex flex-col gap-0.5">
          {genres.map((genre) => (
            <Link
              key={genre.slug}
              to={`/category/${genre.slug}`}
              className="group flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-200 text-foreground-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={genre.icon} />
              </span>
              {genre.name}电影
              <i className="ri-arrow-right-s-line ml-auto text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  );
}